// X-0.B · Xestión do consent de cookies (RGPD).
//
// Persistencia en localStorage cunha versión para invalidar consents antigos
// se cambian as categorías. Emite un CustomEvent `cookie-consent-changed`
// para que outros módulos (analytics loader, etc.) reaxan en tempo real.

const STORAGE_KEY = "cookie_consent";
const VERSION = "1";

export function getConsent() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.version !== VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function hasConsent() {
  return getConsent() !== null;
}

export function saveConsent(categories) {
  const data = {
    version: VERSION,
    timestamp: new Date().toISOString(),
    // necessary é sempre true por definición; non se pode desactivar.
    categories: { ...categories, necessary: true },
  };
  if (typeof window === "undefined") return data;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    window.dispatchEvent(new CustomEvent("cookie-consent-changed", { detail: data }));
  } catch (e) {
    if (typeof console !== "undefined") console.warn("Cookie consent: localStorage failed", e);
  }
  return data;
}

export function clearConsent() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new CustomEvent("cookie-consent-changed", { detail: null }));
  } catch {
    /* noop */
  }
}

export function isCategoryEnabled(category) {
  const c = getConsent();
  return Boolean(c?.categories?.[category]);
}
